/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './sendInteractions.defs'
export { main as default } from './sendInteractions.defs'
